import React, {useEffect, useState}   from "react";
import {Card}                         from "primereact/card";
import {useNavigate}                  from "react-router-dom";
import {Image}                        from 'primereact/image';
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";

import {Botao, Icone} from "./style";

import {LiberarToken, UsuarioMaster} from "../../services/auth";
import iconeCategoria                from '../../assets/categoria.png';
import iconeEspecialidade            from '../../assets/sucesso.png';
import iconeUsuario                  from '../../assets/usuario.png';
import iconeCliente                  from '../../assets/homem-de-negocios.png';
import iconeEvento                   from '../../assets/evento.png';
import iconeParticipante             from '../../assets/clientes.png';
import iconeDocumento                from '../../assets/documento.png';
import iconeSair                     from '../../assets/sair.png';
import Logo                          from '../../assets/LogoLogin.png';
import useMobile                     from "../../hooks/useMobile";

const Menu = () => {
    const {isMobile} = useMobile();
    const navegacao = useNavigate();
    const [master, setMaster] = useState(false);
    const [larguraBotao, setLarguraBotao] = useState('50%');
    const [classeBotao, setClasseBotao] = useState('');
    const [exibeMenu, setExibeMenu] = useState(true);

    useEffect(() => {
        setMaster(UsuarioMaster());
        setLarguraBotao(isMobile ? '50%' : 180);
        setClasseBotao(isMobile ? '' : 'mr-2');
    }, []);

    const acessar = (destino) => {
        if (destino === 'sair') {
            confirmDialog({
                              message        : 'Confirma saída do sistema?',
                              header         : 'Atenção',
                              icon           : 'pi pi-exclamation-triangle',
                              acceptLabel    : 'Sim',
                              acceptClassName: 'p-button',
                              rejectLabel    : 'Não',
                              rejectClassName: 'p-button p-button-outlined',
                              accept         : () => {
                                  LiberarToken();
                                  navegacao('/');
                              },
                          });
        } else {
            navegacao(`/${destino}`);
            if (isMobile) {
                setExibeMenu(false);
            }
        }
    }

    return (<React.Fragment>
        <ConfirmDialog/>
        <Card className='p-align-justify'>
            {isMobile && <React.Fragment>
                <Image src={Logo} title={'EASYSIGN'} alt={'EASYSIGN'} style={{width: 150, margin: 'auto', display: 'block'}} imageStyle={{width: 150, margin: 'auto', display: 'block'}}/><br/>
            </React.Fragment>
            }
            {exibeMenu && <React.Fragment>
                {master && <React.Fragment>
                    <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Categorias'} icon={(ico) => <Icone src={iconeCategoria}/>} onClick={(e) => acessar('categoria')}/>
                    <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Especialidades'} icon={(ico) => <Icone src={iconeEspecialidade}/>} onClick={(e) => acessar('especialidade')}/>
                    <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Usuários'} icon={(ico) => <Icone src={iconeUsuario}/>} onClick={(e) => acessar('usuario')}/>
                    <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Clientes'} icon={(ico) => <Icone src={iconeCliente}/>} onClick={(e) => acessar('cliente')}/>
                </React.Fragment>
                }
                <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Eventos'} icon={(ico) => <Icone src={iconeEvento}/>} onClick={(e) => acessar('evento')}/>
                <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Participantes'} icon={(ico) => <Icone src={iconeParticipante}/>} onClick={(e) => acessar('participante')}/>
                <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Relatório'} icon={(ico) => <Icone src={iconeDocumento}/>} onClick={(e) => acessar('relatorio')}/>
                <Botao severity='primary' className={classeBotao} style={{width: larguraBotao}} outlined label={'Sair'} icon={(ico) => <Icone src={iconeSair}/>} onClick={(e) => acessar('sair')}/>

            </React.Fragment>
            }
            {!isMobile &&
             <Image src={Logo} title={'EASYSIGN'} alt={'EASYSIGN'} style={{width: 150, float: 'right'}} imageStyle={{width: 150}}/>
            }
        </Card>
    </React.Fragment>);
}

export default Menu;